import { Input } from '@salecycle/ui-component-library';
import * as React from 'react';
import { connect } from 'react-redux';

import { ActiveBasketContainsItemWithId } from 'entities/campaign/rules';
import { Actions } from 'sections/campaigns/state/rulesets';
import { OwnProps, Props } from './props';

export type FormProps = Props<ActiveBasketContainsItemWithId>;

export const Form: React.FC<FormProps> = (props: FormProps) => {
  const onChange = (value: string) =>
    props.update(props.rulesetId, props.ruleIndex, {
      productItemIds: value.split(',').map((x: string) => x.trim()),
    });

  return (
    <div data-testid="ActiveBasketContainsItemWithId">
      <Input
        label="Only show RTM when the basket contains any of the following product ids (use commas to separate)"
        ariaLabel="Only show RTM when the basket contains any of the following product ids (use commas to separate)"
        inputId="ProductIdInput"
        onChange={onChange}
        value={props.rule.productItemIds && props.rule.productItemIds.join(', ')}
      />
    </div>
  );
};

export default connect<{}, {}, OwnProps>(null, { update: Actions.editRule })(Form);
